import React, { useEffect, useState } from 'react'
import { Select } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { getEvents } from '../../../services/OdvService'
import useNotifications from '../../../hooks/useNotifications'

export default function OdvEventSelect({ label, placeholder, value, onChange, country }) {
  const { error } = useNotifications()
  const { t } = useTranslation()
  const [events, setEvents] = useState([])

  useEffect(() => {
    let isCurrent = true
    getEvents(country)
      .then((response) => {
        if (isCurrent && response.data) {
          setEvents(
            response.data.map((event) => {
              return {
                value: `${event}`,
                label: t(`odv.event.${event}`, event),
              }
            })
          )
        }
      })
      .catch((err) => {
        error(`Failed to get events: ${err?.response?.statusText}`, err)
      })
    return () => {
      isCurrent = false
    }
  }, [error, country, t])

  return (
    <Select
      label={label}
      placeholder={placeholder}
      value={value}
      onChange={(event) => onChange(event.target.value)}
      options={events}
    />
  )
}
